import React from "react"
import { RenderElementProps } from "slate-react"

const HeadingTeaser = ({ children, attributes }: RenderElementProps) => {
    return (
        <p
            {...attributes}
            className="mb-4 font-gibson text-xl last:mb-0 sm:mb-5 sm:text-4xl lg:text-[50px]/[60px]"
        >
            {children}
        </p>
    )
}

export default HeadingTeaser
